import React from 'react';

export default function Scoring() {
    return (
        <div className="scoring-page">
            <div className="card mb-3">
                <div className="card-body">
                    <h3 className="card-title mb-3">How Scoring Works</h3>
                    <p className="card-text mb-0">
                        Points are earned from your picks for positions #4-#10, your DNF pick, and bonus questions.
                    </p>
                </div>
            </div>

            <div className="card">
                <div className="card-body">
                    <h5 className="mb-3">Position Picks (#4 - #10)</h5>
                    <ul className="mb-0">
                        <li><strong>Exact position match:</strong> 3 points</li>
                        <li><strong>Driver finishes in 4-10, wrong slot:</strong> 1 point</li>
                        <li><strong>Driver not in top 10:</strong> 0 points</li>
                    </ul>
                </div>
            </div>
            
            <div className="card">
                <div className="card-body">
                    <h5 className="mb-3">Correct Picks Bonus</h5>
                    <ul className="mb-0">
                        <li>If you get at least 4 drivers within positions #4-#10, you earn bonus points.</li>
                        <li><strong>4 correct:</strong> +1 bonus point</li>
                        <li><strong>Each additional correct pick above 4:</strong> +2 more points each</li>
                        <li>5 correct = 3 bonus points, 6 correct = 5 bonus points, 7 correct = 7 bonus points</li>
                    </ul>
                </div>
            </div>

            <div className="card">
                <div className="card-body">
                    <h5 className="mb-3">DNF Pick</h5>
                    <ul className="mb-0">
                        <li><strong>You pick a driver that DNF&apos;d:</strong> 2 points</li>
                        <li><strong>You pick “No DNF” and nobody DNF&apos;d:</strong> 1 point</li>
                        <li><strong>Anything else:</strong> 0 points</li>
                    </ul>
                </div>
            </div>

            <div className="card">
                <div className="card-body">
                    <h5 className="mb-3">Bonus Questions</h5>
                    <ul className="mb-0">
                        <li>Each question has its own point value.</li>
                        <li>You earn the full question points for a correct answer.</li>
                        <li>Wrong or unanswered questions earn 0 points.</li>
                    </ul>
                </div>
            </div>

        </div>
    );
}
